import axios from "axios";


const isSet = function (variable){
    return typeof variable !== 'undefined'
}

const getInfo = async function (action, filter = null){
    let result = null,
        data = {
            'action': action
        };

    if(filter !== null){
        data['filter'] = filter;
    }

    const instanceAxios = axios.create();
    instanceAxios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    instanceAxios.defaults.headers.common['content-type'] = 'application/x-www-form-urlencoded';

    await instanceAxios.post('/ajax/postuplenie.php', data).then(response => {
        result = response.data;
    }).catch(error => {
        console.log('error ajax', error)
    });

    return result;
}

export {isSet, getInfo};